module.exports = __webpack_public_path__ + "img/logo.dbb7bc4c.png";